<air-button
    *ngIf="hasBack && !_loading"
    (click)="back()"
    size="small"
    class="mr-1"
>
    Previous Page
</air-button>
<air-button
    *ngIf="hasNext && !_loading"
    (click)="next()"
    size="small"
>
    Next Page
</air-button>
